export default __webpack_public_path__ + "static/media/limb_medium.3754eb5b.jpg";